import React from 'react';
import 'rc-dialog/assets/bootstrap.css';



class Emision extends React.Component {
    constructor( props ) {
        super( props );
       
        this.state = {
                cantidadDeCuotas:undefined,
                cuotasDefaultDesde: this.props.data.GET_PRODUCTO_DEFAULT_VISA_PRODUCTO.cuotasCostoEmisionDesde,
                cuotasDefaultHasta:this.props.data.GET_PRODUCTO_DEFAULT_VISA_PRODUCTO.cuotasCostoEmisionHasta,

                porcBonificacion:undefined,
                porcenBonificacionDesde:undefined,
                porcenBonificacionHasta:undefined,
                
                errorMaximoCuotas:false,
                errorMinimoCuotas:false,
                errorMaximoPorcBonificacion:false,
                errorMinimoPorcBonificacion:false,
                
            };
            this.onEmisionInputBlur = this.onEmisionInputBlur.bind(this);
    }

    onEmisinInputChange(event) {
        const { value, dataset } = event.target;
        const regExp = new RegExp(dataset.validation);

            if (regExp.test(value) || value.replace(/\s/g, "", "") == "") {
                let newState = {
                    [dataset.code]: value
                }
                if (dataset.code == "cuotasEmision") {
                    newState = {
                        ...newState,
                        cantidadDeCuotas: value
                    }
                }
                if (dataset.code == "porcEmision") {
                    newState = {
                        ...newState,
                        porcBonificacion: value
                    }
                }
                this.setState(newState);
                this.onEmisionInputBlur(event);
            }  
    }

    onEmisionInputBlur(e){
        const { value, dataset } = e.target;
        const {  data}= this.props
        const {GET_PRODUCTO_VISA_PRODUCTO_ID} = data
        let productoVisa= GET_PRODUCTO_VISA_PRODUCTO_ID
        
        if(dataset.code =="cuotasEmision"){
           
            if(parseInt(value)>productoVisa.CargoEnCuotasHasta){
                this.setState({
                    errorMaximoCuotas :true,
                    errorMinimoCuotas :false,
                })
            }
            if(parseInt(value)<productoVisa.CargoEnCuotasDesde){
                this.setState({
                    errorMinimoCuotas :true,
                    errorMaximoCuotas :false,
                })
            }            
            if(value==""){
                this.setState({
                    errorMaximoCuotas :false,
                    errorMinimoCuotas :false
                })
            }
            
        }
        if(dataset.code=="porcEmision"){
       
            if(parseInt(value)>productoVisa.PorcBonificacionEmisionHasta){
                this.setState({
                    errorMaximoPorcBonificacion :true,
                    errorMinimoPorcBonificacion :false,
                })
            }
            if(parseInt(value)<productoVisa.PorcBonificacionEmisionDesde){
                this.setState({
                    errorMinimoPorcBonificacion :true,
                    errorMaximoPorcBonificacion :false,
                })
            }            
            if(value==""){
                this.setState({
                    errorMaximoPorcBonificacion :false,
                    errorMinimoPorcBonificacion :false
                })
            }
        }

        this.props.changeInput(dataset.code, value)
    }

    componentDidMount(){
        if(this.props.data.porcentajeCostoEmision!=this.props.porcentajeTarjetas && this.props.porcentajeTarjetas != undefined ){
            this.props.changeInput("porcEmision",this.props.porcentajeTarjetas)
            this.setState({porcBonificacion:this.props.porcentajeTarjetas})
        }else{
            this.setState({porcBonificacion:this.props.data.porcentajeCostoEmision})
        }
        
        if(this.props.data.cuotasCostoEmisionSeleccionadas!=this.props.cuotasTarjetas && this.props.cuotasTarjetas != undefined ){
            this.props.changeInput("cuotasEmision",this.props.cuotasTarjetas)
            this.setState({cantidadDeCuotas:this.props.cuotasTarjetas})
        }else{
            this.setState({cantidadDeCuotas:this.props.data.cuotasCostoEmisionSeleccionadas})
        }
    }

    componentWillReceiveProps(nextProps){
        if(!this.props.data.isFetching && this.props.tarjetas.esModificacion && !this.props.data.emisionModificacion && !this.props.tarjetas.vuelveDeAdicional){

            //SI SE TRATA DE UNA MODIFICACIÓN CARGO LOS VALORES CORRESPONDIENTES A LA SOLICITUD ORIGINAL EN LOS INPUT

            let bonificacion = this.props.tarjetas.datosSolicitud ? this.props.tarjetas.datosSolicitud.BonificacionAlta : null;
            let cuotas = this.props.tarjetas.datosSolicitud ? this.props.tarjetas.datosSolicitud.CuotasBonificacion : null;

            if(bonificacion){
                this.props.changeInput("porcEmision",bonificacion)
                this.setState({porcBonificacion:bonificacion})
            }
            if(cuotas){
                this.props.changeInput("cuotasEmision",cuotas)
                this.setState({cantidadDeCuotas:cuotas})
            }

            //SI LAS SELECCIONES SE REALIZARON CORRECTAMENTE, O BIEN NO CORRESPONDÍAN POR EL PRODUCTO, SE PASA EL FLAG DE CARGA DE DATOS DE LA MODIFICACIÓN A TRUE
            if(((bonificacion && bonificacion == this.props.data.porcentajeCostoEmision) || !bonificacion && this.props.tarjetas.datosSolicitud)&&((cuotas && cuotas == this.props.data.cuotasCostoEmisionSeleccionadas) || !cuotas && this.props.tarjetas.datosSolicitud)) this.props.cargarDatosModificacion("emisionModificacion"); 
        
        }

        if(this.state.porcBonificacion=="" && nextProps.data.porcentajeCostoEmision>0){
            this.setState({porcBonificacion:nextProps.data.porcentajeCostoEmision});
            this.props.changeInput("porcEmision",nextProps.data.porcentajeCostoEmision);
        } 
        if(this.state.cantidadDeCuotas=="" && nextProps.data.cuotasCostoEmisionSeleccionadas>0){
            this.setState({cantidadDeCuotas:nextProps.data.cuotasCostoEmisionSeleccionadas});
            this.props.changeInput("cuotasEmision",nextProps.data.cuotasCostoEmisionSeleccionadas);
        } 

    }
    
            
    render() {
        const { tipoDeCuenta, data}= this.props
        const {GET_PRODUCTO_DEFAULT_VISA_PRODUCTO, GET_PRODUCTO_VISA_PRODUCTO_ID} = data
        let productoVisa= GET_PRODUCTO_VISA_PRODUCTO_ID
        let productoVisaDefault= GET_PRODUCTO_DEFAULT_VISA_PRODUCTO
      
        return (
            ( tipoDeCuenta.EmpresaIndividuos== "I" && 
        <div className = "row"  >
                {productoVisa && <div className="emision col-md-12">
                    <div className="divisor-section bottom-separator" >
                    <h2>Emisión </h2>
                    </div>
                    <div className="emision-body">
                        <div className="form-group bottom-separator-xs">
                            <label className="label-primary">
                            Costo Emisión
                            </label>
                            {productoVisa.CostoEmision =="BP" &&<div>
                                <div>
                                    <label className="label-secondary"> Bonificado Parcialmente </label>
                                    <input 
                                        type="text"
                                        className="input-emision inputAlta" 
                                        maxLength={3}
                                        value={this.state.porcBonificacion}
                                        data-code="porcEmision"
                                        data-validation="^([1-9]?\d|100)$"
                                        onChange={this.onEmisinInputChange.bind(this)}
                                    />
                                    <label className="label-secondary">% </label>
                                    {productoVisaDefault.BonificacionEmisionDefault &&
                                    <label className="label-secondary"> {" ("}{"de "} {productoVisa.PorcBonificacionEmisionDesde}%
                                        {" a "} {productoVisa.PorcBonificacionEmisionHasta}{"%)"}
                                    </label>}
                                </div>
                                <div>
                                {!data.ERROR_CUENTA.porcentajeCostoEmision &&(this.state.errorMaximoPorcBonificacion) &&
                                <label className="error">{"El Costo Emisión debe estar dentro del rango definido por el producto."}</label>}
                                {!data.ERROR_CUENTA.porcentajeCostoEmision&&(this.state.errorMinimoPorcBonificacion) &&
                                <label className="error">{"El Costo Emisión debe estar dentro del rango definido por el producto."}</label>}
                                {!data.ERROR_CUENTA.porcentajeCostoEmision && (!this.state.errorMinimoPorcBonificacion&&!this.state.errorMaximoPorcBonificacion)&&
                                <label className="error">{"Debe ingresar un Porcentaje"}</label>}
                                </div>
                            </div>}
                            {productoVisa.CostoEmision =="BT" &&
                                <div>
                                    <label className="label-secondary">Bonificado al 100%</label>
                                </div>
                            }
                            {productoVisa.CostoEmision =="SB" &&
                                <div>
                                    <label className="label-secondary">Sin Bonificar</label>
                                </div>
                            }
                            {(productoVisa.CostoEmision !=="SC" && productoVisa.CargoEnCuotas)? <div>
                                <div>
                                <label className="label-secondary"> Cantidad de Cuotas </label>
                                <input 
                                    type="text"
                                    className="input-emision inputAlta" 
                                    maxLength={3}
                                    value={this.state.cantidadDeCuotas}
                                    data-code="cuotasEmision"
                                    data-validation="^([1-9]?\d|18)$"
                                    onChange={this.onEmisinInputChange.bind(this)}
                                />
                               { productoVisaDefault.CuotasDefault && 
                               <label className="label-secondary"> ({"Entre "} {productoVisa.CargoEnCuotasDesde}{" y "} 
                                    {productoVisa.CargoEnCuotasHasta} {" cuotas"})
                               </label>}
                                </div>
                               
                                {!data.ERROR_CUENTA.cuotasCostoEmision &&(this.state.errorMaximoCuotas) &&
                                <label className="error">{"La Cantidad de Cuotas debe estar dentro del rango definido por el producto."}</label>}
                                {!data.ERROR_CUENTA.cuotasCostoEmision&&(this.state.errorMinimoCuotas) &&
                                <label className="error">{"La Cantidad de Cuotas debe estar dentro del rango definido por el producto."}</label>}
                                {!data.ERROR_CUENTA.cuotasCostoEmision && (!this.state.errorMinimoCuotas&&!this.state.errorMaximoCuotas)&&
                                <label className="error">{"Ingrese Cantidad de cuotas"}</label>}
                                
                            </div>    
                            :
                            productoVisa.CostoEmision =="SC" && <div>
                            <label className="label-secondary">Sin Cargo</label>
                            </div>        
                         }
                        </div>
                    </div>
                </div>}
        </div >           
       ))
    }
}

export default Emision;